<template>
  <div class="page home-page">
    <section class="hero section-wrap">
      <div class="hero-copy reveal-up">
        <div class="status-row">
          <span class="status-dot"></span>
          <span>Ads ML Infra · Meta</span>
          <span class="status-separator">/</span>
          <span>Bay Area</span>
        </div>

        <p class="hero-overline">SOFTWARE ENGINEER · AGENT BUILDER · HUMAN</p>
        <h1>
          I build systems where
          <span class="marker marker-coral">agents, models</span>
          and people do
          <span class="marker marker-acid">better work.</span>
        </h1>
        <p class="hero-intro">
          I&rsquo;m Gagan Ganapathy—an engineer at Meta working on autonomous systems that
          accelerate model iteration for Ads ranking. I care about ambitious
          infrastructure, thoughtful interfaces, and technology that feels alive.
        </p>

        <div class="hero-actions">
          <router-link class="button button-dark" to="/projects">Explore my work <span>↗</span></router-link>
          <a
            class="text-link"
            href="https://drive.google.com/file/d/1xRvNsz6rxHlLlmIVEcg19kLkpKDlxBZ1/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
          >
            View résumé <span>↗</span>
          </a>
        </div>
      </div>

      <div class="hero-visual reveal-up reveal-delay">
        <div class="portrait-frame">
          <div class="portrait-label">HELLO, INTERNET.</div>
          <img src="../assets/images/mypic2023.jpg" alt="Gagan Ajjikuttira" />
          <div class="portrait-caption">
            <span>Engineer by day</span>
            <span>Curious always</span>
          </div>
        </div>
        <div class="orbit orbit-one" aria-hidden="true">AI / SYSTEMS / UX</div>
        <div class="floating-note note-one" aria-hidden="true">BUILD<br />WITH<br />INTENT</div>
        <div class="floating-note note-two" aria-hidden="true">42<br />∞</div>
      </div>
    </section>

    <div class="ticker" aria-label="Areas of interest">
      <div class="ticker-track">
        <div class="ticker-group">
          <span>AI AGENTS</span><i>✦</i><span>ML INFRA</span><i>✦</i><span>PRODUCT THINKING</span><i>✦</i><span>JAVASCRIPT</span><i>✦</i><span>FORMULA 1</span><i>✦</i>
        </div>
        <div class="ticker-group" aria-hidden="true">
          <span>AI AGENTS</span><i>✦</i><span>ML INFRA</span><i>✦</i><span>PRODUCT THINKING</span><i>✦</i><span>JAVASCRIPT</span><i>✦</i><span>FORMULA 1</span><i>✦</i>
        </div>
      </div>
    </div>

    <section class="career-section section-wrap">
      <div class="section-heading split-heading">
        <div>
          <p class="section-kicker">SELECTED CHAPTERS · 2022—NOW</p>
          <h2>Building at the edge<br />of useful and possible.</h2>
        </div>
        <p class="section-aside">
          A career moving from observability to AI-native talent products to
          autonomous ranking infrastructure.
        </p>
      </div>

      <div class="career-grid">
        <article
          v-for="(role, index) in roles"
          :key="role.company"
          class="career-card"
        >
          <div class="career-index">0{{ index + 1 }}</div>
          <div class="career-meta">
            <span>{{ role.period }}</span>
            <span>{{ role.location }}</span>
          </div>
          <div class="career-body">
            <p class="career-company">{{ role.company }}</p>
            <h3>{{ role.title }}</h3>
            <p>{{ role.description }}</p>
            <div class="tag-list">
              <span v-for="tag in role.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
        </article>
      </div>
    </section>

    <section class="proof-section section-wrap">
      <div class="proof-card proof-dark">
        <div class="proof-symbol">✦</div>
        <p class="section-kicker">A WIN WORTH FRAMING</p>
        <h2>$10K grand prize at the Brembo GenAI Hackathon.</h2>
        <p>
          Our team combined generative AI and classical ML to derive practical
          brake-pad formulations and predict performance from real compositions.
        </p>
        <a href="https://www.linkedin.com/feed/update/urn:li:activity:7125907704966967297" target="_blank" rel="noopener noreferrer">See the story <span>↗</span></a>
      </div>

      <router-link class="proof-card proof-light" to="/read">
        <p class="section-kicker">LATEST WRITING · 5 MIN</p>
        <h2>Understanding post-training of LLMs: RLHF</h2>
        <div class="proof-diagram" aria-hidden="true">
          <span>MODEL</span><i>→</i><span>REWARD</span><i>→</i><span>ALIGN</span>
        </div>
        <span class="proof-link">Enter the reading room <b>↗</b></span>
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: [
        {
          company: "Meta",
          title: "Ads ML Infra",
          period: "JUL 2025 — PRESENT",
          location: "SUNNYVALE, CA",
          description: "Automating the end-to-end model iteration cycle across Meta’s highest-revenue Ads ranking systems using autonomous agents.",
          tags: ["Agents", "ML systems", "Ranking"],
        },
        {
          company: "Eightfold",
          title: "Data & AI Integrations",
          period: "MAR 2024 — JUL 2025",
          location: "SANTA CLARA, CA",
          description: "Scaled platform integrations and helped build AI Recruiter and Voice Screening agents that reshape recruiting workflows.",
          tags: ["AI products", "Platform", "Integrations"],
        },
        {
          company: "Sumo Logic",
          title: "Observability",
          period: "MAY 2022 — MAR 2024",
          location: "REDWOOD CITY, CA",
          description: "Built dashboard experiences and a migration path designed to move millions of classic dashboards to a modern observability platform.",
          tags: ["Observability", "React", "TypeScript"],
        },
      ],
    };
  },
};
</script>
